import ReactModal from "react-modal"
import { Button } from "@inkblot-therapy/squid"
import { Icon } from "../Icon"
import classNames from "classnames"

interface BaseProps {
  isOpen: boolean
  handleClose: () => void
  onConfirm?: () => void
  buttonsFullWidth?: boolean
  title: string
  description: string
  confirmText?: string
}

interface AlertProps extends BaseProps {
  variant: "alert"
}

interface ConfirmProps extends BaseProps {
  variant: "confirmation"
  cancelText?: string
  onCancel?: () => void
}

export type DialogProps = AlertProps | ConfirmProps

export function Dialog(props: DialogProps) {
  const {
    handleClose,
    isOpen,
    title,
    description,
    variant,
    confirmText = "Okay",
    onConfirm,
  } = props

  const handleConfirm = (callback?: () => void) => {
    callback?.()
    handleClose()
  }

  const handleCancel = (callback?: () => void) => {
    callback?.()
    handleClose()
  }

  return (
    <ReactModal
      ariaHideApp={false}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={handleClose}
      overlayClassName="bg-black bg-opacity-20 flex flex-col items-center justify-center w-full h-full fixed top-0 right-0 left-0 bottom-0 z-50"
      className="flex border border-[color:var(--alias-color-border-base)] rounded-[var(--core-border-radius-lg)] flex-col bg-[color:var(--alias-color-bg-base)] max-w-[500px] w-full p-6"
      isOpen={isOpen}
    >
      <div className="flex justify-between pb-11">
        <p className="text-[color:var(--alias-color-text-base)] [font-family:var(--alias-font-display-md-font-family)] [font-size:var(--alias-font-display-md-font-size)] font-bold">
          {title}
        </p>
        <button aria-label="Close modal" onClick={handleClose}>
          <Icon
            aria-label="Select 'X' to close modal"
            variant="X"
            className="text-[color:var(--alias-color-icon-base)]"
          />
        </button>
      </div>
      <p>{description}</p>
      <div className="flex justify-between pt-11 gap-2">
        {variant === "confirmation" ? (
          <Button
            className={classNames(
              "h-[var(--component-button-height-sm)] px-4 text-[14px]",
              {
                "w-1/2": props?.buttonsFullWidth,
              },
            )}
            onClick={() => handleCancel(props.onCancel)}
            variant="critical"
          >
            {props.cancelText ?? "Cancel"}
          </Button>
        ) : null}
        <Button
          className={classNames(
            "h-[var(--component-button-height-sm)] px-4 text-[14px] ml-auto",
            {
              "w-1/2": props?.buttonsFullWidth,
            },
          )}
          onClick={() => handleConfirm(onConfirm)}
          variant="primary"
        >
          {confirmText}
        </Button>
      </div>
    </ReactModal>
  )
}
